import { EquipFromSceneCommand } from "../../core/commands/EquipFromSceneCommand";
import { getComponent, hasComponent, PLAYER_CHARACTER_ID } from "../../world/Entity";
import type { Interaction } from "../Interaction";

/** Wear a clothing item directly from the scene (no inventory step needed). */
export const wearFromSceneInteraction: Interaction = {
  id: "wear-from-scene",
  label: "Wear",
  scope: "scene",
  canExecute: (ctx) => {
    if (!ctx.entity) return false;
    if (!hasComponent(ctx.entity, "wearable")) return false;
    const character = ctx.world.getEntity(PLAYER_CHARACTER_ID);
    return character !== undefined && hasComponent(character, "character");
  },
  execute: async (ctx) => {
    if (!ctx.entity) return { success: false, message: "Nothing to wear." };
    const wearable = getComponent(ctx.entity, "wearable");
    if (!wearable) return { success: false };

    const character = ctx.world.getEntity(PLAYER_CHARACTER_ID);
    if (!character) return { success: false, message: "No character to dress." };

    ctx.commands.execute(new EquipFromSceneCommand(PLAYER_CHARACTER_ID, ctx.entity.id, wearable.slot));
    return { success: true, message: `Kuki is now wearing the ${wearable.slot}!` };
  },
};
